import React from 'react';
import { withTranslation } from 'react-i18next';
import InvestPackage from '../../components/InvestPackage/InvestPackage';

class InvestPackages extends React.Component {
  render () {
    const { t } = this.props;
    return (
      <div>
        <div>
          <h3>{t("investPackage")}</h3>
        </div>
        <div className="grid--custom-Invest">
          <InvestPackage
            className="item-1"
            title={`${t("from")} 2 ${t("shares")}`} // 510 PLN
            desc="Light Blu"
            listAsArray={
              [
                t("fbgroup"),
                t("bgsTicket1")
              ]
            }
          />
          <InvestPackage
            className="item-2"
            title={`${t("from")} 20 ${t("shares")}`} // 5 100 PLN
            desc="Soft Blu"
            listAsArray={
              [
                t("fbgroup"),
                t("bgsTicket4")
              ]
            }
          />
          <InvestPackage
            className="item-3"
            title={`${t("from")} 100 ${t("shares")}`} // 25 500 PLN
            desc="Medium Blu"
            listAsArray={
              [
                t("fbgroup"),
                t("bgsTicket4"),
                t("vipSet")
              ]
            }
          />
          <InvestPackage
            className="item-4"
            title={`${t("from")} 200 ${t("shares")}`} // 51 000 PLN
            desc="Dark Blu"
            listAsArray={
              [
                t("fbgroup"),
                t("bgsTicket4"),
                t("vipSet"),
                t("investorStatue"),
                t("epulpitFree5"),
              ]
            }
          />
          <InvestPackage
            className="item-5"
            title={`${t("from")} 500 ${t("shares")}`} // 127 500 PLN
            desc="Deep Blu"
            listAsArray={
              [
                t("fbgroup"),
                t("bgsTicket4"),
                t("vipSet"),
                t("investorStatue"),
                t("epulpitFree5"),
                t("bgsVip2024"),
                t("productPlacement2024"),
                t("ppvAccess"),
                t("securityAudit"),
                t("trainings")
              ]
            }
          />
        </div>
      </div>
    )
  }
}

export default withTranslation()(InvestPackages)